import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'helpers/AuthProvider';
import LoadingSpinner from 'components/ReusableComponents/LoadingSpinner';
import { saveRedirectAfterLogin } from 'helpers/redirectAfterLogin';

const ProtectedRoute = ({ children, requiredRoles }) => {
  const { authState } = useAuth();
  const location = useLocation();

  if (authState.isLoading) {
    return <LoadingSpinner loading={true} />;
  }

  if (!authState.isLoggedIn) {
    // Remember the requested URL so login can send the user back to it.
    saveRedirectAfterLogin(location);
    return <Navigate to="/signin" replace />;
  }

  if (
    requiredRoles &&
    requiredRoles.length > 0 &&
    (!Array.isArray(authState.groups) ||
      !requiredRoles.some((role) => authState.groups.includes(role)))
  ) {
    return (
      <Navigate
        to="/message"
        replace
        state={{
          textContent:
            'You do not have access to this page. Please contact the administrator.',
          imagePath: '/logo.png',
        }}
      />
    );
  }

  return children;
};
ProtectedRoute.propTypes = {
  children: PropTypes.node,
  requiredRoles: PropTypes.arrayOf(PropTypes.string),
};

export default ProtectedRoute;
